import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IValidationResult } from '../../../classes/validator';

@Component({
	selector: 'material-input',
	template: require('./material-input.component.html')
})
export class MaterialInputComponent {
	private focused = false;

	@Input('value') public value: string;
	@Input('type') public type: string;
	@Input('name') public name: string;
	@Input('required') public required: boolean;
	@Input('iconClass') public iconClass: string;
	@Input('label') public label: string;
	@Input('infoMessage') public infoMsg: string = undefined;
	@Input('color') public color: string;
	@Input('disabled') public disabled: boolean = false;
	@Input('validationRule') public validationRule: (
		inputVal: string,
		compareVal?: string
	) => IValidationResult[];
	@Input('compareWith') public compareWith: string = undefined;
	@Input('showRequiredIndicator') public showRequiredIndicator: boolean = false;
	@Input('validateOnChange') public validateOnChange = false;
	@Input('validationTolerance') public validationTolerance = 0;
	@Input('options') public options: string[];

	public validationResults: IValidationResult[] = [];

	@Output()
	public valueChange: EventEmitter<string> = new EventEmitter();

	@Output()
	public focusLost: EventEmitter<string> = new EventEmitter();

	public executeValidation() {
		if (this.validationRule) {
			setTimeout(() => {
				this.validationResults = this.validationRule(this.value, this.compareWith);
			}, 150);
		}
	}

	public showValidationMessages(): boolean {
		if (this.validationResults) {
			if (this.validationResults.filter(r => !r.isValid && r.required).length > 0) {
				return true;
			} else if (
				this.validationResults.filter(r => !r.isValid).length > this.validationTolerance
			) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	}

	public onFocusOut() {
		this.executeValidation();
		this.focused = false;
		this.focusLost.next(this.value);
	}

	public onChange(event: any) {
		if (this.validateOnChange) {
			this.executeValidation();
		}
		this.valueChange.emit(event);
	}
}
